import { queryStateParser, SerializationType } from '@/utils/useQueryParamState/utils';

export function getURLParam(key: string) {
  if (!window) return null;

  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
}

export function getParsedURLParam<TResult>(key: string, type: SerializationType): TResult | null {
  if (!window) return null;

  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(key);
  return queryStateParser(value, type) as TResult;
}

export const sanitizeUrl = (url: string) => {
  return url.replace(/[^a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=%]/g, '');
};

export const isValidUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export function isValidPathname(pathname: string) {
  return pathname.startsWith('/');
}

/**
 * Clean query params from a URL
 * and return the cleaned url
 * @param url
 */
export function cleanQueryParams(url: string) {
  const parsedUrl = new URL(url);
  return parsedUrl.origin + parsedUrl.pathname;
}
